module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/blackstar-ka.66742b3.png";